import { TextInterpolationVariable } from '../../entities/workoutsession/sessionsequenceentry';

const machineVariable: TextInterpolationVariable = 'machineName';
const secondsUntilPhaseEnds: TextInterpolationVariable = 'secondsUntilPhaseEnds';
const minutesUntilWorkoutEnds: TextInterpolationVariable = 'minutesUntilWorkoutEnds';

const startIn = `Start in {${secondsUntilPhaseEnds}}s`;
const remainingTime = `Remaining {${minutesUntilWorkoutEnds}}m`;
const endsIn = `Remaining {${secondsUntilPhaseEnds}}s`;
const exitIn = `Exit in {${secondsUntilPhaseEnds}}s`;

const MachineWording = {
  offline: 'Offline. Please check app for bookings.',
  bookingRequired: 'App booking required to access',
  notCheckedIn: 'Check-in on app',
  wellDone: 'Well done! Workout complete!',
  noHeartRateMonitor: 'Connect a heart rate device in app',
  endWorkout: `Please end workout on {${machineVariable}}`,
  makeWay: 'Please make way for the next booking',
  stretch: 'Prepare to end workout & stretch',
  prepareWorkout: `Prepare a workout on {${machineVariable}}`,
  startWorkout: 'Start your workout!',
  lastMinute: 'Only 1 minute left!',
  exit: 'Prepare to exit',
  powerPrepareWorkout: 'Please prepare your workout',
  powerEndWorkout: 'Please end your workout',
  progress: {
    startIn,
    remainingTime,
    endsIn,
    exitIn,
  },
};

export default MachineWording;
